<div #modalContainer [id]="id()" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="conversation-modal-title" (keydown.escape)="close.emit()" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
  <div class="relative w-96 max-h-full rounded-lg bg-primary-purple-light-2">
    <div class="relative rounded-lg shadow dark:bg-gray-700 p-6">
      <section class="flex justify-between pb-6">
        <span id="conversation-modal-title" class="text-lg font-bold text-primary-purple">{{ literalService.get('suggestions.modal.conversation.title', true) }}</span>
        <img [src]="images.close" class="w-6 h-6 cursor-pointer" (click)="close.emit()"/>
      </section>
      <section id="conversation-container" class="scrollable-content conversation-wrapper flex flex-col gap-1 h-115.75 overflow-y-auto mb-5">
        @for (key of groupedMessagesKeys; track $index) {
          <div class="text-neutrals-grey-05 flex justify-center items-center pt-6 pb-2">
            {{ key }}
          </div>
          @for (message of groupedMessagesByDate[key]; track message.id) {
            <div class="flex flex-col" [ngClass]="{'items-start': isReceiverMessage(message), 'items-end': !isReceiverMessage(message)}">
              <div class="py-2 px-4 text-base flex flex-col rounded-xl gap-1 w-fit max-w-[90%]" [ngClass]="{'my-message-bubble': !isReceiverMessage(message), 'receiver-message-bubble': isReceiverMessage(message)}">
                {{ message.content }}
                <span class="text-xs">{{ utilsService.convertDate(message.createdAt) | date: 'HH:mm' }}</span>
              </div>
            </div>
          }
        }
      </section>
      <section class="flex flex-col gap-10">
        <div class="flex gap-1.5 justify-between items-center">
          <textarea class="scrollable-content bg-white focus:border-transparent focus:ring-0 w-full rounded max-h-24 p-2 h-16 " [ngClass]="{'cursor-pointer': newMessage.trim() !== ''}" [placeholder]="literalService.get('suggestions.modal.conversation.messagePlaceholder', true)" [value]="newMessage" (keyup)="onChangeMessage($event)"></textarea>
          <img [src]="images.suggestions.sendMessage" class="w-6 h-6" [ngClass]="{'cursor-pointer': newMessage.trim() !== '', 'opacity-50': newMessage.trim() === ''}" (click)="onSendMessage()" />
        </div>
        <input type="button" class="uppercase secondary border-2 cursor-pointer px-4 py-2" [value]="literalService.get('suggestions.modal.conversation.close')" (click)="close.emit()" />
      </section>
    </div>
  </div>
</div>